export default __webpack_public_path__ + "static/media/complex.305dff64.svg";